<main
    class="agpr-themeManagement"
    [ngClass]="{'agpr-themeManagement-maxWidth': themes.length > 0}"
    [agprLoading]="loading"
>
    @if (!loading) {
        @if (themes.length > 0) {
            <section
                class="agpr-themeManagement-content"
                [attr.aria-label]="'Common.layout.main' | localize"
            >
                <div class="agpr-themeManagement-header">
                    <header class="agpr-themeManagement-headerTitle">
                        <h1 class="agpr-themeManagement-headerTitle--main">
                            {{ 'Social.intelligence.themeManagement.title' | localize }}
                        </h1>
                        <span class="agpr-themeManagement-headerTitle--sub">
                            {{ 'Social.intelligence.themeManagement.subtitle' | localize }}
                        </span>
                    </header>
                </div>

                <div class="agpr-themeManagement-center">
                    <agpr-quota-exceeded-banner
                        class="agpr-themeManagement-centerNotification"
                    ></agpr-quota-exceeded-banner>
                    <agpr-scroll-panel #scrollPanel class="agpr-themeManagement-themeListContainer">
                        <h2 class="u-srOnly">
                            {{ 'Social.intelligence.themeManagement.themeList' | localize }}
                        </h2>
                        <ul
                            [id]="id + '_list'"
                            class="agpr-themeManagement-themeList"
                            agprListKeyboardNavigation
                            [focusOnChild]="true"
                            [manageTabIndex]="false"
                            [list]="themes"
                            focusableElementCustomSelector=".agpr-themeCard"
                        >
                            @for (theme of themes; track theme.id) {
                                <li class="agpr-themeManagement-themeCard">
                                    <agpr-theme-card
                                        [theme]="theme"
                                        [expanded]="theme.expanded"
                                        (themeDeleted)="onDeleteTheme($event)"
                                        (themeExpanded)="onToggleExpand($event, theme)"
                                    ></agpr-theme-card>
                                </li>
                            }
                        </ul>
                    </agpr-scroll-panel>

                    <agpr-action-bar [headingContext]="'Social.core.theme' | localize">
                        <ng-template #right>
                            <agpr-button
                                [id]="id + '.action.searchArchive'"
                                label="Social.intelligence.themeManagement.action.searchArchive"
                                [style]="buttonTypes.primaryB"
                                (click)="searchArchive()">
                            </agpr-button>
                            <agpr-button
                                [id]="id + '.action.createTheme'"
                                label="Social.intelligence.themeManagement.action.createTheme"
                                [style]="buttonTypes.primaryB"
                                [disabled]="isCreatingTheme"
                                (click)="createTheme()">
                            </agpr-button>
                        </ng-template>
                    </agpr-action-bar>
                </div>
            </section>

            <aside
                [attr.aria-label]="'Common.layout.rhp' | localize"
                class="agpr-themeManagement-quota"
            >
                <agpr-quota-usage-panel
                    [expanded]="false"
                ></agpr-quota-usage-panel>
            </aside>
        } @else {
            <agpr-hype></agpr-hype>
        }
    }
</main>
